import { dataHooks as createDataHooks } from '@wix/data-hooks'

export const dataHooks = createDataHooks<{
  header: {}
  subtitleAbove: {}
  title: {}
  radioGroup: {}
  next: {}
}>('wix-studio-mobile-radio-group')
